import checkAllRules from './engine'
import safeLocalStorage from '../../../../providers/safeLocalStorageProvider'
import { DIRECT_TRAFFIC_ID, DIRECT_TRAFFIC_SOURCE, NAVIGATION_TRAFFIC_SOURCE } from './constants'

const getTrafficInfo = () => {
  const traffic = {
    url: window.location.href,
    referrer: document.referrer,
  }
  const { trafficSource: newSource, trafficId: newId } = checkAllRules(traffic)
  const trafficInfoKey = 'trafficInfo'
  const sessionLength = 30

  let trafficSource = newSource
  let trafficId = newId

  const trafficInfo = safeLocalStorage.get(trafficInfoKey)
  if (trafficInfo !== null) {
    const { trafficSource: oldSource, trafficId: oldId, timestamp } = trafficInfo
    const timestampValue = new Date(timestamp).getTime()
    const sessionPassed = new Date(timestampValue + sessionLength * 60000) < new Date()
    const isTrafficSourceNavigation = newSource === NAVIGATION_TRAFFIC_SOURCE
    if (isTrafficSourceNavigation) {
      if (sessionPassed) {
        trafficSource = DIRECT_TRAFFIC_SOURCE
        trafficId = DIRECT_TRAFFIC_ID
      } else {
        trafficSource = oldSource
        trafficId = oldId
      }
    }
  }
  safeLocalStorage.set(trafficInfoKey, { trafficSource, trafficId, timestamp: new Date() })

  return { trafficSource, trafficId }
}

export default getTrafficInfo



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/ads/trafficAnalyzer/index.js